import baseTheme from "./baseTheme";
const theme = ({ fontFamily } = {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"'
})=>baseTheme({
        fontFamily,
        themeOverrides: {
            brandColor: '#827127'
        }
    });
export default theme;
